export default __webpack_public_path__ + "static/media/Samsung Galaxy Note10+.dc5d6bc8.png";